import * as types from './mutation-types'

const mutations = {
  [types.SET_USERID](state, userId) {
    state.userId = userId
  },
  STRWEBSITEID(state, status) {
    state.strWebSiteId = status
  }
}

export default mutations
